import React from 'react';
import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { RANGE_OPTIONS, type DashboardFilters } from '@/lib/admin/dashboardFilters';

interface Props {
  filters: DashboardFilters;
  onChange: (next: DashboardFilters) => void;
  showVisitorFilters?: boolean;
}

const DashboardFilterBar: React.FC<Props> = ({ filters, onChange, showVisitorFilters = true }) => {
  const [countryDraft, setCountryDraft] = React.useState(filters.country ?? '');
  React.useEffect(() => setCountryDraft(filters.country ?? ''), [filters.country]);
  return (
  <div
    className="sticky top-16 z-20 mb-6 flex flex-wrap items-center gap-4 rounded-xl border border-border bg-background/90 px-4 py-3 backdrop-blur"
    aria-label="Dashboard filters"
  >
    <div className="flex gap-1" role="group" aria-label="Date range">
      {RANGE_OPTIONS.map((o) => (
        <Button
          key={o.value}
          size="sm"
          variant={filters.range === o.value ? 'default' : 'ghost'}
          aria-pressed={filters.range === o.value}
          onClick={() => onChange({ ...filters, range: o.value })}
        >
          {o.label}
        </Button>
      ))}
    </div>
    {showVisitorFilters && (
      <>
        <div className="flex items-center gap-2">
          <Switch
            id="humans-only"
            checked={filters.humansOnly}
            onCheckedChange={(v) => onChange({ ...filters, humansOnly: v })}
          />
          <Label htmlFor="humans-only" className="text-sm">Humans only</Label>
        </div>
        <div className="flex items-center gap-2">
          <Label htmlFor="country-filter" className="text-sm">Country</Label>
          <Input
            id="country-filter"
            className="h-8 w-20 uppercase"
            maxLength={2}
            placeholder="All"
            value={countryDraft}
            onChange={(e) => {
              const v = e.target.value.toUpperCase().replace(/[^A-Z]/g, '');
              setCountryDraft(v);
              if (v.length === 2) onChange({ ...filters, country: v });
              else if (v.length === 0 && filters.country) onChange({ ...filters, country: null });
            }}
          />
        </div>
      </>
    )}
  </div>
  );
};

export default DashboardFilterBar;
